import React from 'react';
import { useTranslation } from 'react-i18next';
import '../../scss/qr-size.scss';

import CustomRangeInput from '../../../../shared-components/custom-range-input/custom-range-input';

/**
 * QR Size Component
 * @param {any} param0 - The param0
 * @param {any} param0.qrValues - The qrValues prop
 * @param {any} param0.setQrValues - The setQrValues prop
 * @returns {any} The result
 */
function QRSize({ qrValues, setQrValues }: any) {
  const { t } = useTranslation('qrCode');

  const QrSizeProperties = [
    {
      id: 1,
      name: 'qrSize',
      value: qrValues.qrSize,
      label: t('qrSize'),
      min: 150,
      max: 200,
      valueType: 'Px',
    },
    {
      id: 2,
      name: 'qrMargin',
      value: qrValues.qrMargin,
      label: t('margin'),
      min: 10,
      max: 30,
      valueType: 'Px',
    },
  ];

  /**
   * Handling QR Size and Transparency Range Values
   * @param {any} name - The name
   * @param {any} value - The value
   */
  const handleValue = (name: string, value: string | number) => {
    setQrValues((previous: any) => ({
      ...previous,
      [name]: value,
    }));
  };

  return (
    <div className="qr-size-wrap">
      <div className="qr-size">
        {QrSizeProperties.map((Property) => (
          <CustomRangeInput
            key={Property.id}
            label={Property.label}
            name={Property.name}
            value={Property.value}
            valueType={Property.valueType}
            onChange={handleValue}
            min={Property.min}
            max={Property.max}
          />
        ))}
      </div>
    </div>
  );
}

export default QRSize;
